export function run (profile) {
  window.FS.identify(profile.sub, {
    profile: {displayName: profile.displayName, email: profile.email}
  })
}
